import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class ParametresService {

  constructor(private globalService: GlobalService) {}

  get(): Observable<any> {
    return this.globalService.get('/SP-GetSettings/');
  }

  getOuvertureAutomatique(): Observable<any> {
    return this.globalService.get('/SP-GetOuvertureAuto/');
  }

  update(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateSettings/', data);
  }

  add(data: any): Observable<any> {
    return this.globalService.post('/SP-AddSettings/', data);
  }
}
